//
//
//
//
//
//
//
//

import EditInput from '@/components/edit/EditInput';

export default {
    extends: EditInput,

    props: {
        unit: {
            type: [Boolean, String],
            default: false,
        },
    },

    computed: {
        suffix() {
            return (
                !this.unit ? null :
                this.unit === true ? $.getFieldUnit(this.collName, this.fullPath.replace(/\[\d+\]/, ''), this.model) :
                this.unit
            );
        },
    },
};
